import { createSlice } from "@reduxjs/toolkit";
import { getCountries } from "./CountrySelectField.thunk";

const initialState = {
  countries: [],
  status: "idle",
  error: null,
};

export const countrySelectFieldSlice = createSlice({
  name: "countrySelectField",
  initialState,
  reducers: {
    resetCountries: (state) => {
      state.countries = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.countries = action.payload.countries;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error getting countries";
      });
  },
});

export const { resetCountries } = countrySelectFieldSlice.actions;
export default countrySelectFieldSlice.reducer;
